module.exports = __webpack_public_path__ + "img/keyboard-keys-old.a085342e.png";